import { ThunkResult } from 'app/store/helpers';
import { FormsEnum } from 'app/shared/enums';
import { markCheckoutStep } from 'app/store/thunks/addCheckoutDataLayerEvent';

export const onFormActionButtonClick = ({
  formName,
  activeScreen,
}: {
  formName: FormsEnum;
  activeScreen: number;
}): ThunkResult => (dispatch) => {
  if (formName === FormsEnum.CheckoutForm && activeScreen === 0) {
    dispatch(
      markCheckoutStep({
        eventLabel: 'Dane cz. 2',
        ecommerce: {
          checkout: {
            actionField: {
              step: 2,
            },
          },
        },
      })
    );
  }
};
